import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from './../../environments/environment';

export const authConfig: PassedInitialConfig = {
	config: {
		authority: environment.OIDC_AUTHORITY,
		redirectUrl: window.location.origin,
		postLogoutRedirectUri: window.location.origin,
		clientId: environment.OIDC_CLIENT_ID,
		scope: 'openid profile email offline_access read:api write:api delete:api',
		responseType: 'code',
		silentRenew: true,
		useRefreshToken: true,
		renewTimeBeforeTokenExpiresInSeconds: 30,
		tokenRefreshInSeconds: 20, // defaults to 3, which is too frequent for our needs
		useCustomAuth0Domain: true,
		customParamsAuthRequest: {
			audience: environment.OIDC_AUDIENCE,
		},
		customParamsRefreshTokenRequest: {
			scope: 'openid profile email offline_access read:api write:api delete:api',
		},
		logLevel: environment.ENV === 'development' ? LogLevel.Debug : LogLevel.None,
	},
};
